import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { SideBySideSectionIntroEntry } from "frontend/contentful/schema/blocks";
import { SideBySideSectionIntro } from "design-system/components/blocks/side-by-side-section-intro/side-by-side-section-intro";
import { RenderContentfulRichText } from "../utils/render-contentful-rich-text";
import { documentToString } from "frontend/contentful/lib/document-to-string";
import { slugify } from "design-system/utils/slugify";

interface SideBySideSectionIntroOptions {
  headerAbove?: boolean;
}

export const ContentfulSideBySideSectionIntro = createContentfulComponent<
  SideBySideSectionIntroEntry,
  SideBySideSectionIntroOptions
>(({ entry, options, createEditAttributes }) => {
  const headerAbove = options?.headerAbove || false;
  const anchorId = slugify(documentToString(entry.fields.sectionTitle));

  return (
    <SideBySideSectionIntro
      title={
        entry.fields.sectionTitle && (
          <RenderContentfulRichText
            document={entry.fields.sectionTitle}
            disableParagraphs
          />
        )
      }
      subtitle={
        entry.fields.sectionSubtitle && (
          <RenderContentfulRichText document={entry.fields.sectionSubtitle} />
        )
      }
      text={
        entry.fields.introText && (
          <RenderContentfulRichText
            document={entry.fields.introText}
            resetHeaders={headerAbove ? "h4" : "h3"}
          />
        )
      }
      anchorId={anchorId || undefined}
      variant={entry.fields.variant}
      HeadingLevel={headerAbove ? "h3" : "h2"}
      editAttributes={{
        title: createEditAttributes({ entry, fieldId: "sectionTitle" }),
        text: createEditAttributes({ entry, fieldId: "intro" }),
      }}
    />
  );
});
